var React = require('react');

function RightChevron (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9 6.7c-.4.4-.4 1 0 1.4l3.9 3.9L9 15.9c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0l4.6-4.6c.4-.4.4-1 0-1.4l-4.6-4.6c-.4-.4-1-.4-1.4 0z"}));
}

RightChevron.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = RightChevron;

RightChevron.default = RightChevron;
